import React, { useState, useEffect } from "react";
import ManagerCredentials from "../../../components/manager-credentials/ManagerCredentials";
import AlertMessages from "../../../utils/AlertMessages";
import UserService from "../../../services/user-service/UserService";
import CardHeaderUtils from "../../../utils/CardHeaderUtils";
import Loading from "../../../components/loading/Loading";
import { Button, Modal, ModalBody, ModalHeader } from "shards-react";
const ManagerUserCredentials = () => {
    const initialAlertValues = {
        isAlertVisible: false,
        theme: "",
        message: ""
    };

    const [alertValues, setAlertValues] = useState(initialAlertValues);
    const [credentialList, setCredentialList] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [user, setUser] = useState({ email: "", credentials: [] });
    const [menuList, setMenuList] = useState([]);
    const [openModalDeleteMultiple, setOpenModalDeleteMultiple] = useState(
        false
    );
    const [openModalDeleteOne, setOpenModalDeleteOne] = useState(false);
    const [clientIdSelected, setClientIdSelected] = useState(false);
    const [selectedCredentialsList, setSelectedCredentialsList] = useState([]);
    const [allChecked, setAllChecked] = useState(false);

    useEffect(() => {
        async function findUser() {
            try {
                setIsFetching(true);
                const response = await UserService.readSelfUser();
                const _user = response.data;
                setUser({ ...user, ..._user });
                const credentials = _user.credentials || [];
                if (credentials.length > 0) {
                    credentials.sort().reverse();
                    setCredentialList(credentials);
                    setIsFetching(false);
                }
            } catch (e) {
                console.log("error: ", e);
            } finally {
                setIsFetching(false);
            }
        }

        async function getMenuList() {
            const menuItems = CardHeaderUtils.getSettingsMenuList(
                "ManagerUserCredentials"
            );
            setMenuList(menuItems);
        }

        findUser();
        getMenuList();
    }, []);

    const closeAlert = () => {
        setAlertValues({
            ...alertValues,
            ...initialAlertValues
        });
    };

    const commonHandleSuccess = (
        response,
        userDeepClone,
        upatedCredentialList
    ) => {
        const _alertValues = {
            isAlertVisible: true,
            theme: "success",
            message: AlertMessages.messageOnDeleteCredentials(response.status)
        };
        setUser(userDeepClone);
        setCredentialList(upatedCredentialList);
        setAlertValues({ ...alertValues, ..._alertValues });
    };

    const commonHandleError = () => {
        const _alertValues = {
            isAlertVisible: true,
            theme: "danger",
            message: AlertMessages.messageOnDeleteCredentials(
                error && error.response && error.response.status
            )
        };
        setAlertValues({ ...alertValues, ..._alertValues });
    };

    const alertDeleteItem = async clientId => {
        setClientIdSelected(clientId);
        setOpenModalDeleteOne(true);
    };

    const deleteItem = async clientId => {
        setIsFetching(true);
        const upatedCredentialList = credentialList.filter(
            credential => credential.clientId !== clientId
        );
        const userDeepClone = JSON.parse(JSON.stringify(user));
        userDeepClone.credentials = upatedCredentialList;
        try {
            const response = await UserService.deleteSelfCredential(clientId);
            commonHandleSuccess(response, userDeepClone, upatedCredentialList);
        } catch (error) {
            commonHandleError();
        } finally {
            setIsFetching(false);
            setOpenModalDeleteOne(false);
        }
    };

    const handleCheckItem = credential => {
        setCredentialList(prevItens =>
            prevItens?.map(item =>
                item?.clientId === credential?.clientId
                    ? { ...item, checked: !item?.checked }
                    : item
            )
        );
    };

    const filterCredentialListSelected = () => {
        const credentialListCheckedFiltered = credentialList?.filter(
            credential => credential?.checked
        );
        const credentialListFiltered = credentialListCheckedFiltered?.map(
            credential => credential?.clientId
        );

        return {
            credentialsIdList: credentialListFiltered,
            credentialListCheckedFiltered
        };
    };

    const handleConfirmDeleteSelectedCredentials = async () => {
        setSelectedCredentialsList(
            filterCredentialListSelected().credentialsIdList
        );
        setOpenModalDeleteMultiple(true);
    };

    const handleDeleteSelectedCredentials = async () => {
        setIsFetching(true);
        const credentialListUncheckedFiltered = credentialList?.filter(
            credential => !credential?.checked
        );

        const userDeepClone = JSON.parse(JSON.stringify(user));
        userDeepClone.credentials = filterCredentialListSelected().credentialListCheckedFiltered;
        try {
            const response = await UserService.deleteMultipleCredentials({
                credentials: filterCredentialListSelected().credentialsIdList
            });
            commonHandleSuccess(
                response,
                userDeepClone,
                credentialListUncheckedFiltered
            );
        } catch (error) {
            commonHandleError();
        } finally {
            setIsFetching(false);
            setOpenModalDeleteMultiple(false);
        }
    };

    const handleSelectAllCredentials = () => {
        setCredentialList(prevItens =>
            prevItens?.map(item => {
                return { ...item, checked: !allChecked };
            })
        );
        setAllChecked(!allChecked);
    };

    const headTitles = ["", ""];
    return (
        <React.Fragment>
            {isFetching ? (
                <Loading />
            ) : (
                <React.Fragment>
                    <ModalDeleteOneCredentialsComponent
                        openModal={openModalDeleteOne}
                        setOpenModal={setOpenModalDeleteOne}
                        deleteItem={deleteItem}
                        clientIdSelected={clientIdSelected}
                    />
                    <ModalDeleteMultipleCredentialsComponent
                        openModal={openModalDeleteMultiple}
                        setOpenModal={setOpenModalDeleteMultiple}
                        handleDeleteSelectedCredentials={
                            handleDeleteSelectedCredentials
                        }
                        selectedCredentialsList={selectedCredentialsList}
                    />
                    <ManagerCredentials
                        alertValues={alertValues}
                        headTitles={headTitles}
                        credentialList={credentialList}
                        closeAlert={closeAlert}
                        menuList={menuList}
                        name={user?.name}
                        deleteItem={alertDeleteItem}
                        handleCheckItem={handleCheckItem}
                        handleDeleteSelectedCredentials={() =>
                            handleConfirmDeleteSelectedCredentials()
                        }
                        handleSelectAllCredentials={() =>
                            handleSelectAllCredentials()
                        }
                    />
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

const ModalDeleteOneCredentialsComponent = props => {
    const { openModal, setOpenModal, deleteItem, clientIdSelected } = props;

    return (
        <Modal
            centered
            open={openModal}
            toggle={() => setOpenModal(!openModal)}
        >
            <ModalHeader>Deseja remover a credencial?</ModalHeader>
            <ModalBody>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "#fafafa",
                            padding: 20,
                            borderRadius: 20,
                            marginBottom: 10
                        }}
                    >
                        <p style={{ fontWeight: "bold" }}>Credencial:</p>
                        <div
                            style={{
                                overflow: "auto",
                                maxHeight: "300px"
                            }}
                        >
                            <p style={{ margin: 0 }}>{clientIdSelected}</p>
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignSelf: "flex-end"
                        }}
                    >
                        <Button
                            theme="light"
                            style={{ margin: 5 }}
                            onClick={() => setOpenModal(false)}
                        >
                            Cancelar
                        </Button>
                        <Button
                            theme="danger"
                            style={{ margin: 5 }}
                            onClick={() => deleteItem(clientIdSelected)}
                        >
                            Excluir
                        </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

const ModalDeleteMultipleCredentialsComponent = props => {
    const {
        openModal,
        setOpenModal,
        handleDeleteSelectedCredentials,
        selectedCredentialsList
    } = props;

    return (
        <Modal
            centered
            open={openModal}
            toggle={() => setOpenModal(!openModal)}
        >
            <ModalHeader>
                Deseja remover as credenciais selecionadas?
            </ModalHeader>
            <ModalBody>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "#fafafa",
                            padding: 20,
                            borderRadius: 20,
                            marginBottom: 10
                        }}
                    >
                        <p style={{ fontWeight: "bold" }}>Credenciais:</p>
                        <div
                            style={{
                                overflow: "auto",
                                maxHeight: "300px"
                            }}
                        >
                            {selectedCredentialsList?.map(
                                (selectedCredential, index) => (
                                    <p
                                        style={{ margin: 0 }}
                                        key={`${index * new Date().getTime()}`}
                                    >
                                        {selectedCredential}
                                    </p>
                                )
                            )}
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignSelf: "flex-end"
                        }}
                    >
                        <Button
                            theme="light"
                            style={{ margin: 5 }}
                            onClick={() => setOpenModal(false)}
                        >
                            Cancelar
                        </Button>
                        <Button
                            theme="danger"
                            style={{ margin: 5 }}
                            onClick={() => handleDeleteSelectedCredentials()}
                        >
                            Excluir
                        </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ManagerUserCredentials;
